import { apiFetch } from "./node-service-api";

export type SearchHierarchyNodeResponse = {
    id: number;
    parentId?: number;
    name: string;
    reference: string;
    allowPartitionChildren: boolean;
};

export type GetHierarchyNodeDescendantResponse = {
    name: string;
    level: number;
};

export type GetHierarchyNodeResponse = {
    id: number;
    parentId?: number;
    name: string;
    reference: string;
    allowPartitionChildren: boolean;
    descendants: GetHierarchyNodeDescendantResponse[];
};

export type UpdateHierarchyNodeRequest = {
    name: string;
    reference: string | null;
    allowPartitionChildren: boolean;
};

export type CreateHierarchyNodeRequest = {
    fieldCompanyId: number;
    parentId?:number;
    name: string;
    reference: string | null;
    allowPartitionChildren: boolean;
};

export const hierarchynodesSearchUrlPath = "/hierarchynodes/search";

export const hierarchynodesUrlPath = "/hierarchynodes"

const searchHierarchByFieldCompanyId = async (fieldCompanyId: number): Promise<SearchHierarchyNodeResponse[]> => {
    return await apiFetch<SearchHierarchyNodeResponse[]>(`${hierarchynodesSearchUrlPath}?fieldCompanyId=${fieldCompanyId}`, {
        headers: { "Content-Type": "application/json" },
    });
}

export async function getHierarchyNodeById(nodeId: number): Promise<GetHierarchyNodeResponse> {
    return await apiFetch<GetHierarchyNodeResponse>(`${hierarchynodesUrlPath}/${nodeId}/`, {
        headers: { "Content-Type": "application/json" },
    });
}

export async function updateHierarchyNode(nodeId: number, request: UpdateHierarchyNodeRequest ): Promise<void> {
    await apiFetch<void>(`${hierarchynodesUrlPath}/${nodeId}`, {
        method: "PUT",
        body: JSON.stringify(request),
        headers: { "Content-Type": "application/json" },
    });
}

export async function createHierarchyNode(request: CreateHierarchyNodeRequest): Promise<void> {
    return await apiFetch<void>(`${hierarchynodesUrlPath}`, {
        method: "POST",
        body: JSON.stringify(request),
        headers: { "Content-Type": "application/json" },
    });
}

export async function deleteHierarchyNode(nodeId: number): Promise<void> {
    return await apiFetch<void>(`${hierarchynodesUrlPath}/${nodeId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
    });
}


export { searchHierarchByFieldCompanyId }